import React, { FC } from 'react';
import classNames from 'classnames';
import { BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import { CTA_COLORS, TypeCtaColors } from '@/components/common/types';
import { getCTAStyles, getCtaTextStyles } from '@/components/utils';
import { ChevronIcon } from '@/components';

export interface GenExternalLinkProps {
  href: string;
  cta: string;
  noFollow?: boolean;
  blankTarget?: boolean;
  onClick?: () => void;
  style?: 'Link' | 'Primary' | 'Secondary' | undefined;
  ctaColor?: TypeCtaColors;
  classes?: string;
  hasLeadingArrow?: boolean;
}

const GenExternalLink: FC<GenExternalLinkProps> = ({
  href,
  cta,
  noFollow,
  blankTarget,
  onClick,
  style = BUTTON_STYLES.link,
  ctaColor = CTA_COLORS.DEFAULT,
  classes = '',
  hasLeadingArrow,
}) => {
  return (
    <a
      data-testid="link-genExternaLink"
      href={href}
      className={classNames(
        'w-fit flex flex-row items-center gap-1.5',
        {
          ['underline font-bold']: style === BUTTON_STYLES.link,
          [getCtaTextStyles()]: style === BUTTON_STYLES.link,
          [getCTAStyles(ctaColor)]: style === BUTTON_STYLES.primary,
          ['btn btn-primary']: style === BUTTON_STYLES.primary,
        },
        classes,
      )}
      rel={noFollow ? 'nofollow' : undefined}
      target={blankTarget ? '_blank' : undefined}
      onClick={onClick ? onClick : undefined}
    >
      {hasLeadingArrow && (
        <ChevronIcon
          color="indigo"
          direction="left"
          height={13}
          width={13}
          strokeWidth={3}
          classes={'relative top-[1px]'}
        />
      )}
      {cta}
    </a>
  );
};

export default React.memo(GenExternalLink);
